<div style="max-width: 800px">
    @if (survey) {
    @switch (survey.type) {
    @case ('email') {
    <ell-survey-email [survey]="survey" (complete)="complete($event)" />
    }

    @case ('consent') {
    <ell-survey-consent [survey]="survey" (complete)="complete($event)" />
    }

    @case ('writer') {
    <ell-survey-writer [survey]="survey" (complete)="complete($event)" />
    }

    @case ('file') {
    <ell-survey-file [survey]="survey" [file]="survey.describesFile" (complete)="complete($event)" />
    }
    }
    }
</div>
